
































import { Component, Inject, Vue } from "vue-property-decorator";
import { Button, Toast } from "vant";
import request from "@/api/index";
import { verifier } from "@/common/utils";
import store from "@/store/index";
@Component({
  components: {
    "van-button": Button
  }
})
export default class Phone extends Vue {
  /** 倒计时 */
  countDown = 0;
  /** 验证码 */
  code = "";
  /** 手机号 */
  phone = "";
  /** 定时器 */
  timer!: any;

  @Inject("openId")
  openId!: string;

  get buttonText() {
    if (this.countDown > 0) {
      return `重新发送(${String(this.countDown).padStart(2, "0")})`;
    } else {
      return "获取验证码";
    }
  }

  get canLogin() {
    if (this.code && this.phone && this.checkPhone) {
      return true;
    } else {
      return false;
    }
  }

  get checkPhone() {
    if (verifier(this.phone, 2)) {
      return true;
    } else {
      return false;
    }
  }

  close() {
    this.$emit("close", "phone");
  }

  async getCode() {
    const result = await request.sendvalidcode(this.phone);
    if (!result.code) {
      this.countDown = 60;
      this.timer = setInterval(() => {
        this.countDown -= 1;
        if (this.countDown === 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    } else {
      Toast.fail({
        message: result.message
      });
    }
  }

  async bindPhone() {
    const result = await request.userBindPhone({
      openId: this.openId,
      phone: this.phone,
      smsCode: this.code
    });
    if (!result.code) {
      Toast("绑定成功");
      this.close();
      store.commit("SET_STATE", {
        isOpenWxBindPhone: false
      });
      window.location.reload();
    } else {
      this.code = "";
      Toast.fail({
        message: result.message
      });
    }
  }
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  }
}
